import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction,toJS} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../../contexts";
import {custom} from "../../../utils/linker";
import DragTarget from "../../Helpers/DragAndDrop/DragTarget";
import DropTarget from "../../Helpers/DragAndDrop/DropTarget";

function FileSmall(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compStore=useContext(ComponentContext);

  useEffect(() => {
    // mount
    return () => {
      // unmount
    }
  }, []);

  const isUploading=()=>{

  };
  const getValue=()=>{
    return compStore.getCur(props.item).tmp_file || compStore.getCur(props.item);
  };
  const getSrc=()=>{
    return (compStore.getCur(props.item).tmp_file && compStore.getCur(props.item).tmp_file.preview)?compStore.getCur(props.item).tmp_file.preview:(compStore.getCur(props.item).preview || null);
  };

  const findFileById=(id)=> {
    for (let i in compStore.data) {
      if (compStore.data[i].sys_uid === id) {
        return {index: parseInt(i), field: compStore.data[i]};
      }
    }
    return null;
  };

  const prepareSort=()=> {

    compStore.prepareSort();

  };

  const onDrop=(onWhat, what, position)=>{
    // return false;
    runInAction(()=>{
      for(let i in what) {
        if(onWhat.sys_uid === what[i].sys_uid) {
          return false;
        }
      }
      if(onWhat.sys_uid !== what.sys_uid) {
        const whatArr=[];
        for(let i in what) {
          const whatOb = findFileById(what[i].sys_uid);
          const extracted = compStore.data.splice(whatOb.index, 1);
          whatArr.push(extracted[0]);
        }

        if (whatArr.length) {
          // const extracted = compStore.data.splice(whatOb.index, 1);
          const onWhatOb = findFileById(onWhat.sys_uid);
          if (position === "left") {
            Array.prototype.splice.apply(compStore.data, [onWhatOb.index, 0].concat(whatArr));
          }
          if (position === "right") {
            Array.prototype.splice.apply(compStore.data, [onWhatOb.index+1, 0].concat(whatArr));
          }
          prepareSort();
        }
      }
    });
  };
  const isDragging=()=>{
    for(let i in compStore.dragging.data) {
      if(compStore.dragging.data[i].sys_uid == props.item.sys_uid) {
        return true;
      }
    }
    return false;
  };
  const getDragElement=()=>{
    if(compStore.dragging.data && compStore.dragging.data.length > 1) {
      return (
        <div className="bg-w1 bg padd10 solid1 rad3 bo-w5 wsnw" style={{width: 150}}>
          Выбрано файлов: {compStore.getSelected().length}
        </div>
      )
    } else {
      return null;
    }
  };
  const getDragArr=()=>{
    if(compStore.getSelected().length) {
      if(compStore.isSelected(props.item.sys_uid)) {
        return compStore.getSelected();
      }
    }
    return [props.item];
  };

  return (
    <div className={`cell padd5 noselect pointer pr ${isDragging()?"transp100":""}`} onClick={(e)=>{
      compStore.clickOnItem(e, props.item);
      /*const isSelected=compStore.isSelected(props.item.sys_uid);
      if(!e.shiftKey) {
        compStore.clearSelection();
      }
      if(isSelected && !e.shiftKey) {
        // compStore.selectItem(props.item);
      } else {
        compStore.toggleItem(props.item);
      }*/
    }}>
      <DragTarget customDragElement={getDragElement()} item={getDragArr()} noDragging={false} dragLinker={custom(compStore, "dragging").linker}>
        <div  className={`bg-w2-op50 soldi1 bo-w3 rad3 pr `}>
          {compStore.dragging.active?(
            <>
              <DropTarget width={10} onDrop={(onWhat, what, position)=>{ onDrop(onWhat, what, position); }} item={props.item} position={"left"} dragLinker={custom(compStore, "dragging").linker} />
              <DropTarget width={10} onDrop={(onWhat, what, position)=>{ onDrop(onWhat, what, position); }} item={props.item} position={"right"} dragLinker={custom(compStore, "dragging").linker} />
            </>
          ):null}

          <div style={{paddingBottom:'100%'}} className="pr">
            <div className="pa pa-tl w100 h100 up12 splice">
              <div className="cell s-12 s-middle">
                {props.item.uploading?(
                  <div className="hpadd20 ptop40">
                    <div className="ptop2 rad4 ofh bg-w3 pr">
                      <div className="pa pa-tl h100 bg-pc1" style={{width:`${props.item.progress}%`}}></div>
                    </div>
                  </div>
                ):(
                  <>
                    {props.item.fail?(
                      <div className="b1 padd20 tac">
                        <div className="b5 mdi mdi-image-remove fs24 pbottom10"></div>
                        Файл не<br/>
                        загрузился
                      </div>
                    ):(
                      <>
                        {getSrc()?(
                          <img src={getSrc()} className="db center" draggable={false} />
                        ):(
                          <div>
                            <div className=" b1 fs12 lh14 tac ptop20 ofh ttu bold center mtop10 pr " style={{backgroundColor: getValue().color, height:60, width: 45}}>
                              <div className="pa pa-tr bg-w2" style={{borderColor:`#F8F8F8 #F8F8F8 #ffffff #ffffff`, borderWidth:10, borderStyle:"solid"}}></div>
                              <div className="pa pa-bl fs12 bold w1 pleft5 pbottom2">{getValue().ext}</div>
                            </div>
                            <div className="ptop5 tac w5 fs12 hpadd5 ptop10" style={{wordBreak:"break-word"}}>
                              {getValue().file_name}
                            </div>
                          </div>
                        )}
                      </>

                    )}

                  </>
                )}

              </div>
            </div>
            {compStore.isSelected(props.item.sys_uid)?(
              <>
                <div className="pa pa-tl w100 h100 solid2 rad3 bo-pc1"></div>
                {compStore.getSelected().length>1?(
                  <div className="pa pa-tr rad200 bg-pc1 w1 fs14 tac mtop10 mright10 ptop2" style={{width:20, height:20}}>
                    {compStore.getSelectionNumber(props.item.sys_uid)+1}
                  </div>
                ):null}
              </>
            ):null}
          </div>
        </div>
      </DragTarget>
      {props.item.delete?(
        <div className="pa pa-tl w100 h100 bg-w1-op30">
          <div className="up12 splice h100">
            <div className="cell s-12 s-middle tac const1 fs11">
              Фото будет удалено<br/>
              при сохранении
            </div>
          </div>
        </div>
      ):null}
    </div>
  )
};

FileSmall.defaultProps = {};

FileSmall.propTypes = {}

export default observer(FileSmall);
